import { deleteEventViaCallable } from "./eventLinks";

// Deletes the protected links subdoc too. Deleting only the Event doc would
// orphan it forever, since no client can read or delete it.
const removeEvent = async ({ eventId }: { eventId: string }) =>
  deleteEventViaCallable({ eventId });

export default removeEvent;
